import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Comment } from '../models/comment.model';
import { ApolloService } from './apollo.service';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  constructor(private apolloService: ApolloService) {}
  private return =
    '{id, articleId, name, date, text, commentResponses{name, date, text}}';

  getComments(): Observable<Comment[]> {
    return this.apolloService.query<Comment[]>(
      `{comments${this.return}}`,
      'comments'
    );
  }

  getComment(commentId: string): Observable<Comment> {
    return this.apolloService.query<Comment>(
      `{comment(id:"${commentId}")${this.return}}`,
      'comment'
    );
  }

  getArticleComments(articleId: string): Observable<Comment[]> {
    return this.apolloService.query<Comment[]>(
      `{commentsByArticle(articleId:"${articleId}")${this.return}}`,
      'commentsByArticle'
    );
  }

  createComment(comment: Comment): Observable<Comment> {
    return this.apolloService.mutate<Comment>(
      `CreateComment($comment: CreateCommentInput!) {
        createComment(createCommentInput: $comment)${this.return}
      }`,
      'createComment',
      { comment }
    );
  }

  updateComment(comment: Comment): Observable<Comment> {
    return this.apolloService.mutate<Comment>(
      `UpdateComment($comment: UpdateCommentInput!) {
        updateComment(updateCommentInput: $comment)${this.return}
      }`,
      'updateComment',
      { comment }
    );
  }

  deleteComment(commentId: string): Observable<boolean> {
    return this.apolloService
      .mutate<number>(
        `RemoveComment($commentId: UUID!) {
            removeComment(id: $commentId)
        }`,
        'removeComment',
        { commentId }
      )
      .pipe(map((x) => x > 0));
  }
}
